import { useTask } from '~/contexts/TaskContext'
import {
  MessageType,
  messageTypeFromJSON,
  TaskStatusAndRequestResponseTuple
} from '~/protos/agents'
import { csvToMarkdown } from '~/utils/shared'

export function getCodeDeltaContent(tuple: TaskStatusAndRequestResponseTuple) {
  const responses = tuple.response ?? []

  const getLatest = (extractor: (stream: any) => string | undefined): string => {
    for (let i = responses.length - 1; i >= 0; i -= 1) {
      const value = extractor(responses[i]?.responseContentStream)
      if (value && value.trim() !== '') return value
    }
    return ''
  }

  return (
    getLatest(stream => stream?.dataweaveOutput?.code) ||
    getLatest(stream => stream?.dataweaveOutput?.userMarkdownMsg) ||
    getLatest(stream => stream?.migrationDocOutput?.docMd) ||
    getLatest(stream => stream?.migrationDocOutput?.endpointsMd) ||
    getLatest(stream => {
      const docs = stream?.migrationDocOutput?.migDocs
      return docs?.length ? docs.join('\n\n') : undefined
    }) ||
    getLatest(stream => stream?.document?.mappingSheetMd) ||
    getLatest(stream =>
      stream?.document?.mappingSheetCsv ? csvToMarkdown(stream.document.mappingSheetCsv) : undefined
    ) ||
    getLatest(stream => stream?.document?.dwlMd) ||
    getLatest(stream => stream?.deltaContent)
  )
}

export function getCodeReviewBriefContent(tuple: TaskStatusAndRequestResponseTuple) {
  const responses = tuple.response ?? []

  for (let i = responses.length - 1; i >= 0; i -= 1) {
    const stream = responses[i]?.responseContentStream
    const summary = stream?.coderSummary?.summary?.trim()
    if (summary) return summary
  }

  for (let i = responses.length - 1; i >= 0; i -= 1) {
    const stream = responses[i]?.responseContentStream
    const content = stream?.deltaContent?.trim()
    if (!content) continue

    const messageType = messageTypeFromJSON(stream?.messageType)
    const hasDiffPayload =
      (stream?.diff?.length ?? 0) > 0 || (stream?.migrationDocOutput?.diffs?.length ?? 0) > 0

    if (messageType === MessageType.DIFF || hasDiffPayload) return content
  }

  return ''
}

export function useCodeDeltaContent(index?: number) {
  const { task: taskObj } = useTask()
  if (taskObj == null) {
    return ''
  }
  const items = taskObj.details.orderedStateResponses
  const response = items[index ?? items.length - 1]
  return getCodeDeltaContent(response)
}
